import { useMemo } from 'react';
import { Outlet, generatePath, useParams } from 'react-router';

import { TabNav, TabsNav } from '@fly/core';
import { routes } from '@fly/shared';
import { t } from 'i18next';

const tabs: TabNav[] = [
  {
    to: routes.DASHBOARD.RUNTIME_ENVIRONMENTS.ENVIRONMENT.DEPLOYMENTS,
    label: t('app.dashboard.runtime_environments.deployments.title', {
      defaultValue: 'Deployments',
    }),
  },
  {
    to: routes.DASHBOARD.RUNTIME_ENVIRONMENTS.ENVIRONMENT.TOKEN,
    label: t('app.dashboard.runtime_environments.tokens.title', {
      defaultValue: 'Tokens',
    }),
  },
];

const EnvironmentSkeleton = () => {
  const { environmentId } = useParams();

  const environmentTabs = useMemo(
    () =>
      tabs.map((tab: TabNav) => ({
        ...tab,
        to: generatePath(tab.to!, { environmentId }),
      })),
    [environmentId]
  );

  return (
    <div className='flex h-full w-full flex-col'>
      <TabsNav
        data-testid='runtime-environment-tabs'
        size='2'
        tabs={environmentTabs}
        className='relative -left-fly-7 w-[calc(100%+var(--fly-number-spacing-7)*2)] overflow-visible pl-fly-5'
      />
      <section
        data-testid='runtime-environment-container'
        className='mt-fly-6 flex h-full w-full flex-col'
      >
        <Outlet />
      </section>
    </div>
  );
};

export default EnvironmentSkeleton;
